import omit from 'lodash.omit'

import {
  deleteOfferRequest,
  getCategories,
  getOpportunitiesRequest,
  sendNewOfferRequest,
  sendOfferRequest,
} from '@http/endpoints'

export default {
  namespaced: true,
  state: () => ({
    opportunitiesTotal: undefined,
    opportunities: [],
    categories: [],
    filters: {
      category_id: 'all',
      ordering: 'date_creation',
      product_state_functional: undefined,
      product_state_aspect: undefined,
      merchant_auction: undefined,
    },
    activePage: 1,
  }),
  getters: {
    opportunities: (state) => state.opportunities,
    opportunitiesTotal: (state) => state.opportunitiesTotal,
    categories: (state) => state.categories,
    filters: (state) => state.filters,
    activePage: (state) => state.activePage,
  },
  mutations: {
    setOpportunities(state, payload) {
      state.opportunities = payload
    },
    setOpportunitiesTotal(state, payload) {
      state.opportunitiesTotal = payload
    },
    setCategories(state, payload) {
      state.categories = payload.map(({ pk: value, label }) => ({
        value: value.toString(),
        label,
      }))
    },
    setFilters(state, payload) {
      state.filters = payload
    },
    setActivePage(state, payload) {
      state.activePage = payload
    },
  },
  actions: {
    setFilters: ({ commit }, object) => commit('setFilters', object),

    setActivePage: ({ commit }, value) => commit('setActivePage', value),

    async getOpportunities({ commit, dispatch }, allParams) {
      let params = allParams

      if (params && params.category_id === 'all') {
        params = omit(allParams, ['category_id'])
      }

      const {
        payload: { results, count },
      } = await dispatch(
        'http/request',
        {
          request: getOpportunitiesRequest,
          queryParams: params,
        },
        { root: true },
      )

      // Opportunities that we can see inside ONLY ONE page (pagination).
      commit('setOpportunities', results)
      // All opportunities (all pageS).
      commit('setOpportunitiesTotal', count)
    },

    async getCategories({ commit, dispatch }) {
      const {
        payload: { results },
      } = await dispatch(
        'http/request',
        {
          request: getCategories,
        },
        { root: true },
      )
      commit('setCategories', results)
    },

    sendOffer: ({ dispatch }, { priceHuman, clientOffer }) =>
      dispatch(
        'http/request',
        {
          request: sendOfferRequest,
          body: {
            price_human: priceHuman,
            client_offer: clientOffer,
          },
        },
        { root: true },
      ),

    sendNewOffer: ({ dispatch }, { priceHuman, clientOffer, id }) =>
      dispatch(
        'http/request',
        {
          request: sendNewOfferRequest,
          pathParams: { id },
          body: {
            price_human: priceHuman,
            client_offer: clientOffer,
          },
        },
        { root: true },
      ),

    deleteOffer: ({ dispatch }, id) =>
      dispatch(
        'http/request',
        {
          request: deleteOfferRequest,
          pathParams: { id },
        },
        { root: true },
      ),
  },
}
